import React from "react";

/**
 * Spanish ultrasound waiver — waiver espanol.docx
 * Items 1–14 numbered for clarity; footer (firma/fecha) omitted.
 */
function SpanishWaiverUltrasoundContent() {
  return (
    <div style={{ textAlign: "justify" }}>
      <p>
        <strong>CONSENTIMIENTO Y EXENCIÓN DE RESPONSABILIDAD</strong>
      </p>
      <p>
        Como condición para recibir los servicios de ultrasonido de Little
        Bellies (también conocida como Pancitas Franchising LLC y denominada
        &quot;LB&quot;), por medio del presente instrumento declaro, reconozco,
        entiendo y acepto lo siguiente:
      </p>
      <ol className="px-3">
        <li>
          LB no es un proveedor de atención médica, y ninguno de sus servicios
          está destinado a ser, ni debe considerarse, un servicio médico. Ninguno
          de los servicios de LB es adecuado para diagnosticar, monitorear,
          confirmar o tratar cualquier condición médica que afecte a mi feto o a
          mí. Aunque los ultrasonidos pueden ser utilizados por proveedores de
          atención médica con fines clínicos, los ultrasonidos de LB son
          exclusivamente para propósitos sentimentales y no clínicos.
        </li>
        <li>
          Estoy bajo el cuidado de un médico u otro proveedor de atención médica
          (mi &quot;Proveedor&quot;) para mi embarazo. No utilizaré este
          ultrasonido ni ningún otro servicio de LB como reemplazo de la atención
          y el tratamiento proporcionados o recomendados por mi Proveedor.
          Notificaré a mi Proveedor sobre todos los servicios que he recibido o
          que tengo intención de recibir de LB, incluyendo, entre otros, un
          ultrasonido. Por la presente autorizo a LB a entregar una copia de mi
          ultrasonido a mi Proveedor si así lo solicita.
        </li>
        <li>
          He informado a LB sobre cualquier condición médica, alergia u otra
          inquietud de salud que pueda afectar mis sesiones con LB. Me comprometo
          a mantener a LB informada si mi estado de salud cambia.
        </li>
        <li>
          Entiendo que los servicios de LB implican contacto físico y que puedo
          detener o modificar la sesión en cualquier momento. Le haré saber de
          inmediato a LB si siento dolor, incomodidad o tengo alguna inquietud.
        </li>
        <li>
          El ultrasonido y otros servicios que pueda recibir de LB generalmente no
          están cubiertos por un seguro. Por lo tanto, pagaré por los servicios de
          LB por adelantado.
        </li>
        <li>
          El técnico que realiza el ultrasonido no es médico, enfermero/a ni
          proveedor de atención médica, y no puede interpretar ni diagnosticar
          condiciones médicas a partir del ultrasonido, ni elaborar informes
          clínicos del mismo, ni ofrecer asesoramiento médico sobre las imágenes
          producidas.{" "}
          <strong>
            Este ultrasonido no será leído ni interpretado por ningún médico,
            enfermero/a u otro proveedor de atención médica en ningún momento.
          </strong>{" "}
          Si y cuando comparta las imágenes de ultrasonido creadas por LB,
          informaré al destinatario que el ultrasonido fue preparado
          exclusivamente con fines sentimentales y no es adecuado para uso
          clínico.
        </li>
        <li>
          Este ultrasonido de recuerdo tiene como objetivo proporcionar imágenes
          mejoradas con el fin de que yo pueda observar el movimiento fetal en el
          útero, y no constituye un ultrasonido médico integral ni una evaluación
          del bienestar fetal.
        </li>
        <li>
          Me comunicaré con mi Proveedor, y no con LB, si tengo alguna pregunta
          sobre este ultrasonido de recuerdo o cualquier otro aspecto de mi
          embarazo.
        </li>
        <li>
          La calidad del ultrasonido de recuerdo y del DVD u otro medio
          audiovisual depende de muchos factores, entre ellos: el contenido del
          tejido corporal, la etapa de desarrollo y la posición fetal. LB no
          garantiza la calidad del DVD u otro medio audiovisual, ni la capacidad
          de visualizar características del feto.
        </li>
        <li>
          Entiendo que la publicación, presentación o distribución de cualquier
          video grabado durante la sesión de ultrasonido por parte de cualquier
          persona que no sea LB está estrictamente prohibida.
        </li>
        <li>
          Por la presente otorgo a LB una licencia vitalicia y no exclusiva para
          utilizar todas y cada una de las imágenes y videoclips tomados durante
          mi sesión, u otros materiales (el &quot;Contenido&quot;), con fines
          promocionales en todas las plataformas, incluyendo, entre otras, sitios
          web y redes sociales (p. ej., Facebook, Instagram, TikTok, Twitter/X,
          YouTube) que hagan referencia o etiqueten a LB, ya sea publicado por LB
          o por terceros, sin previo aviso ni compensación para mí.
        </li>
        <li>
          Por la presente autorizo a LB, sus filiales, socios y proveedores de
          servicios a comunicarse conmigo mediante teléfono, mensaje de voz,
          correo electrónico y mensaje de texto para cualquier fin, incluyendo,
          entre otros, el envío de imágenes y videos de mis sesiones, encuestas,
          ofertas promocionales y otras comunicaciones de marketing.
        </li>
        <li>
          La falta de experiencia clínica de LB y los factores que escapan a su
          control pueden afectar la capacidad de determinar con precisión el sexo
          del feto, y LB no puede ni garantiza la claridad del ultrasonido ni la
          exactitud de cualquier determinación del sexo.
        </li>
        <li>
          Aunque los ultrasonidos generalmente se consideran seguros y no utilizan
          radiación, entiendo que los ultrasonidos utilizan ondas de sonido de alta
          frecuencia que pueden causar aumentos muy leves en la temperatura del
          tejido, y acepto todos y cada uno de los riesgos asociados con ello.
        </li>
      </ol>
      <p>
        <strong>
          EN CONSIDERACIÓN DE LOS SERVICIOS PRESTADOS, ACEPTO EXIMIR Y LIBERAR DE
          TODA RESPONSABILIDAD A LITTLE BELLIES, SUS AGENTES, FILIALES, MIEMBROS,
          GERENTES Y EMPLEADOS DE TODAS Y CADA UNA DE LAS RECLAMACIONES O ACCIONES
          POR LESIONES, DAÑOS, PERJUICIOS U OTRA RESPONSABILIDAD QUE RESULTEN DE, O
          SE ALEGUE QUE HAYAN RESULTADO DE, ESTE ULTRASONIDO DE RECUERDO Y TODOS
          LOS DEMÁS SERVICIOS PRESTADOS POR LITTLE BELLIES, INCLUYENDO, ENTRE
          OTROS, EL INCUMPLIMIENTO DE UN ULTRASONIDO DE LITTLE BELLIES PARA
          DETERMINAR CON PRECISIÓN EL SEXO FETAL U OTRAS CARACTERÍSTICAS O
          ANOMALÍAS, Y CUALQUIER DAÑO O LESIÓN DERIVADO DEL ULTRASONIDO QUE
          ACTUALMENTE NO SE SEPA QUE PUEDA OCURRIR.
        </strong>
      </p>
      <p>
        Elijo voluntariamente recibir los servicios de LB y asumo plena
        responsabilidad por mi participación. He leído detenidamente este
        documento y, al firmar al pie, reconozco que comprendo plenamente y
        acepto su contenido.
      </p>
    </div>
  );
}

export default SpanishWaiverUltrasoundContent;
